export enum RouteVehicleType {
    BUS = 1,
    SMALL_BUS = 2 // Buseta
}